<template>
  <a-config-provider :locale="customLocale">
    <div
        class="
        flex
        min-h-full
        w-full
        main-preloader
        justify-content-center
        align-item-center
      "
        v-if="isPreloader"
    >
      <preloader/>
    </div>
    <div class="flex min-h-full w-full" v-if="!isRedirect && !registrationRole" :class="{ 'sidebar-collapsed': isSidebarCollapsed }">
      <MainHeader :sidebarCollapsed="isSidebarCollapsed" class="nav"/>
      <MainSidebar :updatedGroup="updatedGroup" @toggle="handleSidebarToggle"/>
      <div class="page-container" ref="pageContainerRef">
        <router-view
            @updateHeader="(id) => {
            updatedGroup = id;
          }"
        />
        <div class="mt-5 document-link">
          <div>
            <span>© {{ new Date().getFullYear() }} WAY2WEI</span>
            <a class="margin-span"
               href="https://way2wei.ru/document/privacy_policy"
               target="_blank">
              Политика обработки данных
            </a>
          </div>
        </div>
      </div>
      <div v-if="isGlobalLoad" class="page-preloader">
        <preloader/>
      </div>
      <notifications
          animation-name="notif"
          :duration="10000"
          :max="5"
          :closeOnClick="true"
          classes="vue-notification custom-modifications"
      />
    </div>
    <redirect-page v-if="isRedirect"/>
    <registration-role @roleChoice="selectedRole" v-if="registrationRole"/>
    <popup-technical-work
        v-if="showTechnicalModal"
        @closeModal="showTechnicalModal = false"
        :title="`На сайте ведутся техничекие работы`"
    ></popup-technical-work>
    <pop-up-change-password
        v-if="profile && isChangeRequired"
        :profile="profile"
        :open="isChangeRequired"
        @close = "isChangeRequired = false"
    />
    <unfinished-passing-notification />

    <feedback-form v-if="feedbackFormShown" :open="feedbackFormShown" />
  </a-config-provider>
</template>

<script>
import {computed, onBeforeMount, ref, watch} from "@vue/runtime-core";
import {useStore} from "vuex";
import $ from "jquery";
import axios from "axios";
import MainHeader from "./components/Header/MainHeader.vue";
import MainSidebar from "./components/Header/MainSidebar.vue";
import useBreakpoints from "./mixins/useBreakpoints";
import useCheckVersion from "./mixins/useCheckVersion";
import RedirectPage from "./components/Technical/RedirectPage.vue";
import RegistrationRole from "./components/Technical/RegistrationRole.vue";
import {useRoute, useRouter} from "vue-router";
import {notify} from "@kyvg/vue3-notification";
import Preloader from "./components/Technical/Preloader.vue";
import useCheckStatusTechnicalWork from "./mixins/useCheckTechnicalWork";
import popupTechnicalWork from "@/components/popup-technical-work/PopupTechnicalWork.vue";
import PopUpChangePassword from "@/components/Popups/PopUpChangePassword.vue";
import ruRU from 'ant-design-vue/es/locale/ru_RU'
import {message} from "ant-design-vue";
import UnfinishedPassingNotification from "@/views/Notifications/UnfinishedPassingNotification.vue";
import {nextTick} from "vue";
import FeedbackForm from "@/components/Support/SupportModal.vue";

export default {
  components: {
    FeedbackForm,
    UnfinishedPassingNotification,
    PopUpChangePassword,
    MainHeader,
    MainSidebar,
    RedirectPage,
    RegistrationRole,
    Preloader,
    popupTechnicalWork,
  },
  provide: {
    imageUrl: 'https://cabinet.way2wei.ru',
  },
  setup() {
    const store = useStore(),
        route = useRoute(),
        router = useRouter();

    let isSidebarCollapsed = ref(false);

    const handleSidebarToggle = (collapsed) => {
      isSidebarCollapsed.value = collapsed;
    }

    const {checkStatusTechnicalWork} = useCheckStatusTechnicalWork();
    const updatedGroup = ref(0);
    const {width} = useBreakpoints();
    const isRedirect = computed(() => store.state.redirectProcess),
        profile = computed(() => store.state.profile.profile),
        companyTrap = computed(() => store.state.companyTrap),
        userCompany = computed(() => store.state.company.userCompany),
        isGlobalLoad = computed(() => store.state.isGlobalLoad),
        registrationRole = ref(false),
        isPreloader = ref(false),
        isChangeRequired = ref(false),
        feedbackFormShown = computed(() => store.state.support.showForm);

    const {checkVersion} = useCheckVersion();

    let showTechnicalModal = ref(false),
        currentStatusTechnicalWork = ref('')

    axios.interceptors.response.use(
        function (response) {
          return response;
        },
        function (error) {
          if (error.message === 'Network Error') {
            showTechnicalModal.value = true
          }
          if (error.response) {
            // checkStatusTechnicalWork()
          }
        });

    const selectedRole = (role) => {
      const updatedProfile = profile.value;
      updatedProfile.role = role;
      store
          .dispatch("profile/updateProfile", updatedProfile)
          .then(() => {
            registrationRole.value = false;
            //Тут определяем что делать при какой роли
            if (role == "private_person") {
              router.push("/personal");
            } else {
              //Ловушка на компанию которая не дает перейти никуда кроме компании ехехехех
              store.commit("setCompanyTrap", true);
              router.push("/company");
            }
          })
          .catch((error) => {
            message.error('Ошибка');
          });
    };

    router.beforeEach((to, from) => {
      store.commit("setIsGlobalLoad", false);
      !from.name
          ? store.commit("setShowBack", false)
          : store.commit("setShowBack", true);
      if (companyTrap.value && to.path !== "/company") {
        return "/company";
      }
    });

    onBeforeMount(() => {
      isPreloader.value = true;
      // Запись токена авторизации
      let tokenList = document.cookie.match(new RegExp("ei-token=([^;]*)"))

      if (tokenList) {
        let token = tokenList[1];

        const user = {
          token: `Bearer ${decodeURI(token)}`,
        };
        let mainToken = document.cookie.match(
            new RegExp("ei-token-main=([^;]*)")
        );
        if (mainToken) {
          user.externalEnter = true;
        }

        axios.defaults.headers.common = {
          Authorization: `Bearer ${decodeURI(token)}`,
          "Content-Type": "application/json",
        };
        axios.defaults.withCredentials = process.env.NODE_ENV === 'production';
        store.commit("setUser", user);
        currentStatusTechnicalWork.value = localStorage.getItem("statusTechnicalWork");
      }

      store
          .dispatch("profile/getProfile")
          .then(() => {
            if (profile.value.password_change_required) isChangeRequired.value = true;
            if (!profile.value.role) registrationRole.value = true;
            if (profile.value.role == "admin") {
              store.dispatch("company/getUserCompany").then(() => {
                if (!userCompany.value.name || !userCompany.value.inn) {
                  store.commit("setCompanyTrap", true);
                  router.push("/company");
                }
              });
            }

            store.dispatch('getSimulators')
            store.dispatch("getCourseLink");

            if (profile.value.id) {
              store.dispatch('subscription/getPermittedSubscriptions', profile.value?.company?.id ?? null);
            }
          })
          .finally(() => (isPreloader.value = false));
      store.commit("setWidth", width);
      // Автоматический фокус на текстовом поле при открытии select2
      $(document).on("select2:open", (e) => {
        const selectId = e.target.id;
        $(
            ".select2-search__field[aria-controls='select2-" +
            selectId +
            "-results']"
        ).each(function (key, value) {
          value.focus();
        });
      });
      // checkVersion();
    });

    watch(currentStatusTechnicalWork, () => {
      if (currentStatusTechnicalWork.value !== '200') {
        showTechnicalModal.value = true
      }
    })

    const customLocale = computed(() => ({
      ...ruRU,
      Table: {
        ...ruRU.Table,
        triggerDesc: 'Сортировать по убыванию',
        triggerAsc: 'Сортировать по возрастанию',
        cancelSort: 'Сбросить сортировку',
      },
    }));

    const pageContainerRef = ref(null)

    watch(
        () => route.fullPath,
        async () => {
          await nextTick();

          pageContainerRef.value?.scrollTo({
            top: 0,
            behavior: 'smooth',
          });
        }
    )

    return {
      customLocale,
      isRedirect,
      registrationRole,
      profile,
      router,
      selectedRole,
      companyTrap,
      userCompany,
      isPreloader,
      isGlobalLoad,
      showTechnicalModal,
      isChangeRequired,
      updatedGroup,
      isSidebarCollapsed,
      handleSidebarToggle,
      pageContainerRef,
      feedbackFormShown
    };
  },

  mounted() {
    const store = useStore();
    const profile = computed(() => store.state.profile.profile);
    const metrikaLoaded = ref(false);
    document.addEventListener('yacounter' + process.env.VUE_APP_YA_METRIC_COUNTER + 'inited', () => {
      metrikaLoaded.value = true;
    })

    watch(() => [profile.value, metrikaLoaded.value],
        () => {
          if (profile.value && profile.value.id && metrikaLoaded.value) {
            this.$metrika.userParams({
              UserID: profile.value.id
            })
          }
        });
  }
};
</script>

<style lang="scss">
@import "./assets/css/kf";
@import "./assets/css/common.scss";
@import "./assets/css/print.scss";
@import "./assets/css/poppers-styles.scss";

body {
  font-family: "Open Sans", sans-serif;
  line-height: 120%;
  font-weight: 400;
  background-color: var(--neutral-grey);
  overflow-y: hidden;
  color: var(--main-font);
}

:root {
  --tablet-breakpoint: 1359px;
  --phone-breakpoint: 767px;
  --max-width: 1600px;

  --focus-color: #E9FFD4;
  --main-green: #21AC0C;
  --hover-green: #4FC23A;
  --active-green: #1C960A;

  --disabled: #D9D9D9;

  --polar-green: #F6FFED;
  --polar-green-3: #B7EB8F;
  --polar-green-6: #52C41A;
  --primary-link-green: #1C8F0A;

  --sunset-orange: #FA8C16;
  --sunset-orange-1: #FFF7E6;
  --sunset-orange-3: #FFD591;

  --warning-color-1: #FAAD14;
  --warning-color-2: #FFFBE6;
  --warning-color-3: #FFE58F;

  --dust-red: #FFF1F0;
  --dust-red-1: #FFA39E;
  --dist-red-main: #F5222D;

  --neutral-grey: #F5F5F5;
  --grey-text: #8C8C8C;
  --border-grey: #D9D9D9;
  --light-grey: #FAFAFA;

  --geek-blue: #2F54EB;
  --geek-blue-1: #F0F5FF;
  --geek-blue-3: #ADC6FF;

  --neutral-black-font: rgb(0, 0, 0, 0.65);
  --neutral-fade-black-font: rgb(0, 0, 0, 0.25);
  --neutral-text-description: rgb(0, 0, 0, 0.45);

  --color-error: #F5222D;

  --main-font: rgb(0, 0, 0, 0.88);

  --main-blue: #2F54EB;
  --xs-continer-gap: 30px;
  --main-color: #2cc185;
  --main-color70: #2cc185b9;
  --hover-color: #337f61;
  --light-color: #7fd3b0;
  --dark-color: #323232;
  --cream-color: #eceeef;
  --common-text-color: #545454;
  --chart-color: #2cc185;
  --chart-line-color: #2c68c1;
  --icons-color: #45a780;

  --tracker-color-yellow: #fde80c;
  --tracker-color-blue: #183695;
  --tracker-color-green: #6dba33;
  --tracker-color-red: #fd0a07;

}

@font-face {
  font-family: "Open Sans";
  src: url("./assets/fonts/OpenSans-VariableFont_wdth,wght.woff2") format("woff2");
  font-weight: 300 700;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: "Open Sans";
  src: url("./assets/fonts/OpenSans-Italic-VariableFont_wdth,wght.woff2") format("woff2");
  font-weight: 300 700;
  font-style: italic;
  font-display: swap;
}

* {
  padding: 0;
  margin: 0;
  border: 0;
}

*,
*:before,
*:after {
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

*::selection {
  color: white;
  background-color: var(--hover-color);
}

a:active,
:active {
  outline: none;
}

nav,
footer,
header,
aside,
main,
details {
  display: block;
}

html,
body,
#app {
  height: 100%;
  width: 100%;
  line-height: 120%;
  font-size: 16px;
  -ms-text-size-adjust: 100%;
  -moz-text-size-adjust: 100%;
  -webkit-text-size-adjust: 100%;
  overflow-x: hidden;
  position: relative;
}

#app {
  position: unset;
  margin-top: 62px;
}

.main-preloader {
  background-color: white;
  z-index: 15;
  position: absolute;
  opacity: 95%;
  top: 0;
  left: 0;
}

input,
button,
textarea {
  font-family: inherit;
}

input::-ms-clear {
  display: none;
}

button {
  cursor: pointer;
}

button::-moz-focus-inner {
  padding: 0;
  border: 0;
}

a,
a:visited {
  text-decoration: none;
}

a:hover {
  text-decoration: none;
}

ul li {
  list-style: none;
}

img {
  vertical-align: top;
}

h1 {
  font-size: 2em;
  margin: 0.67em 0;
}

a {
  background-color: transparent;
}

abbr[title] {
  border-bottom: none; /* 1 */
  text-decoration: underline; /* 2 */
  text-decoration: underline dotted; /* 2 */
}

b,
strong {
  font-weight: bolder;
}

small {
  font-size: 80%;
}

img {
  border-style: none;
}

button,
input,
optgroup,
select,
textarea {
  font-family: inherit;
  font-size: 100%;
  line-height: 1.15;
  margin: 0;
}

button,
input {
  overflow: visible;
}

button {
  background-color: transparent;
}

button,
select {
  text-transform: none;
}

button,
[type="button"],
[type="reset"],
[type="submit"] {
  -webkit-appearance: button;
}

button::-moz-focus-inner,
[type="button"]::-moz-focus-inner,
[type="reset"]::-moz-focus-inner,
[type="submit"]::-moz-focus-inner {
  border-style: none;
  padding: 0;
}

button:-moz-focusring,
[type="button"]:-moz-focusring,
[type="reset"]:-moz-focusring,
[type="submit"]:-moz-focusring {
  outline: 1px dotted ButtonText;
}

progress {
  vertical-align: baseline;
}

textarea {
  overflow: auto;
}

[type="number"]::-webkit-inner-spin-button,
[type="number"]::-webkit-outer-spin-button {
  height: auto;
}

[type="search"] {
  -webkit-appearance: textfield;
  outline-offset: -2px;
}

[type="search"]::-webkit-search-decoration {
  -webkit-appearance: none;
}

::-webkit-file-upload-button {
  -webkit-appearance: button;
  font: inherit;
}

summary {
  display: list-item;
}

[hidden] {
  display: none;
}

@media (max-width: 768px) {
  .nav {
    background: #ffffff;
  }
}

.document-link {
  font-size: 12px;
  margin-top: auto !important;
  flex-shrink: 0;
  position: sticky;
  bottom: 0;
  padding: 20px 0;
  background-color: var(--neutral-grey);
  color: var(--neutral-fade-black-font);
  z-index: 10;

  .margin-span {
    margin-left: 10px;
  }

  a {
    color: var(--neutral-fade-black-font);
  }

  a:hover {
    color: var(--main-green);
  }
}

.page-container {
  height: calc(100vh - 60px);
  overflow-y: auto;
}


@media (max-width: 1150px) {
  .document-link {
    position: static;
    margin-top: 20px !important;
    padding-top: 0;
    background-color: transparent;
  }
}

.blue-alert {
  padding: 2px 10px;
  font-weight: 400;
  background-color: var(--geek-blue-1);
  border: 1px solid var(--geek-blue-3)
}

.ant-tag-green {
  color: var(--polar-green-6);
  background-color: var(--polar-green);
}

.yellow-tag {
  color: var(--warning-color-1);
  background-color: var(--warning-color-2);
  border-color: var(--warning-color-3);
}

.blue-tag {
  color: var(--geek-blue);
  background-color: var(--geek-blue-1);
  border-color: var(--geek-blue-3);
}

.red-tag {
  color: var(--dist-red-main);
  background-color: var(--dust-red);
  border-color: var(--dust-red-1);
}

.green-tag-text {
  color: var(--polar-green-6);
}

.blue-tag-text {
  color: var(--geek-blue);
}

.yellow-tag-text {
  color: var(--warning-color-1);
}

.red-tag-text {
  color: var(--dist-red-main);
}
</style>
